var _a;
import { generateHooks } from "../generators/generator.hooks";
import { GENERATOR_PARAMS } from "./payin.constants";
export var usePaged = (_a = generateHooks(GENERATOR_PARAMS), _a.usePaged), useDetail = _a.useDetail, useCount = _a.useCount;
